import gql from 'graphql-tag';

const FIRMWARE_VERSION_LIST = gql`
  query Query {
    firmwareVersionList {
      version
    }
  }
`;

export default FIRMWARE_VERSION_LIST;
